var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.262,
    height: 73.25,
    viewBox: "0 0 73.262 73.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_48",
    "data-name": "Komponente 10 \\u2013 48",
    transform: "translate(0.263 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day-and-night",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35541",
    "data-name": "Gruppe 35541",
    transform: "translate(6.101 6.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35537",
    "data-name": "Gruppe 35537",
    transform: "translate(37.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35536",
    "data-name": "Gruppe 35536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35535",
    "data-name": "Gruppe 35535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46814",
    "data-name": "Pfad 46814",
    d: "M359.545,65.757a2.173,2.173,0,0,1-1.536-3.71l.845-.845-3.975-3.975a2.176,2.176,0,0,1,0-3.073l3.928-3.928a2.176,2.176,0,0,1,3.073,0l3.975,3.975.845-.845a2.173,2.173,0,0,1,3.709,1.572l-.139,8.552a2.164,2.164,0,0,1-2.137,2.137l-8.552.139h-.036Zm.8-14.321a.326.326,0,0,0-.231.1l-3.928,3.928a.327.327,0,0,0,0,.463l4.627,4.627a.923.923,0,0,1,0,1.305l-1.5,1.5a.327.327,0,0,0,.23.559h.007l8.552-.139a.326.326,0,0,0,.322-.322l.139-8.552a.327.327,0,0,0-.559-.237l-1.5,1.5a.923.923,0,0,1-1.305,0l-4.627-4.627A.325.325,0,0,0,360.344,51.436Z",
    transform: "translate(-354.245 -49.591)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35540",
    "data-name": "Gruppe 35540",
    transform: "translate(0 37.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35539",
    "data-name": "Gruppe 35539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35538",
    "data-name": "Gruppe 35538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46815",
    "data-name": "Pfad 46815",
    d: "M59.648,370.4a2.167,2.167,0,0,1-1.537-.635l-3.975-3.975-.845.845a2.173,2.173,0,0,1-3.709-1.572l.139-8.552a2.164,2.164,0,0,1,2.138-2.137l8.552-.139a2.173,2.173,0,0,1,1.572,3.709l-.845.845,3.975,3.975a2.176,2.176,0,0,1,0,3.073l-3.928,3.928a2.167,2.167,0,0,1-1.536.635Zm-5.512-6.838a.92.92,0,0,1,.653.27l4.627,4.627a.327.327,0,0,0,.463,0l3.928-3.928a.327.327,0,0,0,0-.463l-4.627-4.627a.923.923,0,0,1,0-1.305l1.5-1.5a.311.311,0,0,0,.07-.359.318.318,0,0,0-.307-.2l-8.552.139a.326.326,0,0,0-.322.322l-.139,8.552a.327.327,0,0,0,.559.237l1.5-1.5a.92.92,0,0,1,.653-.27Z",
    transform: "translate(-49.582 -354.234)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35554",
    "data-name": "Gruppe 35554",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35542",
    "data-name": "Gruppe 35542",
    transform: "translate(27.058 27.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46816",
    "data-name": "Pfad 46816",
    d: "M237.7,255.843a18.142,18.142,0,0,1-17.77-14.491,1.651,1.651,0,0,1,2.865-1.407,12.15,12.15,0,0,0,9.207,4.22h0a12.077,12.077,0,0,0,7.14-2.315.923.923,0,1,1,1.085,1.493,13.91,13.91,0,0,1-8.224,2.667h0a13.99,13.99,0,0,1-10.1-4.3,16.294,16.294,0,1,0,19.8-19.8,14.014,14.014,0,0,1,1.919,17.926.923.923,0,0,1-1.53-1.032,12.169,12.169,0,0,0-2.15-16,1.651,1.651,0,0,1,1.408-2.865,18.139,18.139,0,0,1-3.648,35.907Z",
    transform: "translate(-219.897 -219.902)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35553",
    "data-name": "Gruppe 35553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35543",
    "data-name": "Gruppe 35543",
    transform: "translate(6.945 7.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46817",
    "data-name": "Pfad 46817",
    d: "M112.1,195.936a13.914,13.914,0,0,1-7.715-2.322.923.923,0,1,1,1.02-1.538,12.132,12.132,0,0,0,18.645-8.027.923.923,0,1,1,1.819.315A13.94,13.94,0,0,1,112.1,195.936Z",
    transform: "translate(-98.122 -167.985)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46818",
    "data-name": "Pfad 46818",
    d: "M59.913,81.6a.922.922,0,0,1-.743-.375A13.977,13.977,0,1,1,84.177,70.455a.923.923,0,0,1-1.817.324,12.131,12.131,0,1,0-21.705,9.344.923.923,0,0,1-.742,1.471Z",
    transform: "translate(-56.444 -58.952)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35544",
    "data-name": "Gruppe 35544",
    transform: "translate(19.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46819",
    "data-name": "Pfad 46819",
    d: "M163.448,5.069a.923.923,0,0,1-.923-.923V.924a.923.923,0,1,1,1.846,0V4.146A.923.923,0,0,1,163.448,5.069Z",
    transform: "translate(-162.525 -0.001)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46820",
    "data-name": "Pfad 46820",
    d: "M163.448,308.944a.923.923,0,0,1-.923-.923V304.8a.923.923,0,1,1,1.846,0v3.222A.923.923,0,0,1,163.448,308.944Z",
    transform: "translate(-162.525 -266.485)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35545",
    "data-name": "Gruppe 35545",
    transform: "translate(13.053 1.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46821",
    "data-name": "Pfad 46821",
    d: "M108.1,14.825a.923.923,0,0,1-.867-.607l-1.1-3.028a.923.923,0,0,1,1.734-.631l1.1,3.028a.924.924,0,0,1-.867,1.239Z",
    transform: "translate(-106.079 -9.951)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46822",
    "data-name": "Pfad 46822",
    d: "M212.036,300.375a.923.923,0,0,1-.867-.608l-1.1-3.028a.923.923,0,0,1,1.734-.631l1.1,3.028a.924.924,0,0,1-.867,1.239Z",
    transform: "translate(-197.222 -260.365)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35546",
    "data-name": "Gruppe 35546",
    transform: "translate(6.945 4.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46823",
    "data-name": "Pfad 46823",
    d: "M59.439,42.925a.921.921,0,0,1-.707-.33l-2.071-2.468a.923.923,0,0,1,1.414-1.186l2.071,2.468a.923.923,0,0,1-.706,1.516Z",
    transform: "translate(-56.445 -38.612)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46824",
    "data-name": "Pfad 46824",
    d: "M254.767,275.706a.921.921,0,0,1-.707-.33l-2.071-2.468a.923.923,0,0,1,1.414-1.186l2.071,2.468a.923.923,0,0,1-.707,1.516Z",
    transform: "translate(-227.738 -242.749)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35547",
    "data-name": "Gruppe 35547",
    transform: "translate(2.412 10.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46825",
    "data-name": "Pfad 46825",
    d: "M23.315,85.972a.918.918,0,0,1-.461-.124l-2.79-1.611a.923.923,0,0,1,.923-1.6l2.79,1.611a.923.923,0,0,1-.462,1.722Z",
    transform: "translate(-19.603 -82.515)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46826",
    "data-name": "Pfad 46826",
    d: "M286.48,237.91a.918.918,0,0,1-.461-.124l-2.79-1.611a.923.923,0,0,1,.923-1.6l2.79,1.611a.923.923,0,0,1-.462,1.722Z",
    transform: "translate(-250.386 -215.758)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35548",
    "data-name": "Gruppe 35548",
    transform: "translate(0 16.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46827",
    "data-name": "Pfad 46827",
    d: "M4.1,138.779a.925.925,0,0,1-.161-.014l-3.173-.56a.923.923,0,1,1,.32-1.818l3.173.559a.923.923,0,0,1-.159,1.832Z",
    transform: "translate(0 -136.373)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46828",
    "data-name": "Pfad 46828",
    d: "M303.357,191.547a.922.922,0,0,1-.161-.014l-3.173-.559a.923.923,0,1,1,.32-1.818l3.173.559a.923.923,0,0,1-.159,1.832Z",
    transform: "translate(-262.437 -182.648)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35549",
    "data-name": "Gruppe 35549",
    transform: "translate(0 16.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46829",
    "data-name": "Pfad 46829",
    d: "M.923,191.546a.923.923,0,0,1-.159-1.832l3.173-.56a.923.923,0,1,1,.32,1.818l-3.173.559a.939.939,0,0,1-.161.014Z",
    transform: "translate(-0.001 -182.648)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46830",
    "data-name": "Pfad 46830",
    d: "M300.182,138.778a.923.923,0,0,1-.159-1.832l3.173-.559a.923.923,0,1,1,.32,1.818l-3.173.559A.924.924,0,0,1,300.182,138.778Z",
    transform: "translate(-262.437 -136.373)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35550",
    "data-name": "Gruppe 35550",
    transform: "translate(2.412 10.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46831",
    "data-name": "Pfad 46831",
    d: "M20.527,237.91a.923.923,0,0,1-.462-1.722l2.79-1.611a.923.923,0,0,1,.923,1.6l-2.79,1.611A.919.919,0,0,1,20.527,237.91Z",
    transform: "translate(-19.603 -215.758)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46832",
    "data-name": "Pfad 46832",
    d: "M283.691,85.973a.923.923,0,0,1-.462-1.722l2.79-1.611a.923.923,0,1,1,.923,1.6l-2.79,1.611A.919.919,0,0,1,283.691,85.973Z",
    transform: "translate(-250.385 -82.516)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35551",
    "data-name": "Gruppe 35551",
    transform: "translate(6.945 4.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46833",
    "data-name": "Pfad 46833",
    d: "M57.367,275.705a.923.923,0,0,1-.707-1.516l2.071-2.468a.923.923,0,0,1,1.414,1.186l-2.071,2.468A.921.921,0,0,1,57.367,275.705Z",
    transform: "translate(-56.445 -242.748)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46834",
    "data-name": "Pfad 46834",
    d: "M252.7,42.923a.923.923,0,0,1-.706-1.516l2.071-2.468a.923.923,0,0,1,1.414,1.186L253.4,42.593a.921.921,0,0,1-.707.33Z",
    transform: "translate(-227.738 -38.609)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35552",
    "data-name": "Gruppe 35552",
    transform: "translate(13.053 1.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46835",
    "data-name": "Pfad 46835",
    d: "M107,300.376a.923.923,0,0,1-.867-1.239l1.1-3.028a.923.923,0,0,1,1.734.631l-1.1,3.028A.924.924,0,0,1,107,300.376Z",
    transform: "translate(-106.079 -260.366)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46836",
    "data-name": "Pfad 46836",
    d: "M210.934,14.826a.923.923,0,0,1-.867-1.239l1.1-3.028a.923.923,0,0,1,1.734.631l-1.1,3.028A.924.924,0,0,1,210.934,14.826Z",
    transform: "translate(-197.222 -9.953)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35556",
    "data-name": "Gruppe 35556",
    transform: "translate(-321.001 -2888)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#a5b5af",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46717",
    "data-name": "Pfad 46717",
    d: "M23.5,6l-7.692,7.7L13.5,11.392",
    transform: "translate(360.5 2936.15)",
    fill: "none",
    stroke: "#a5b5af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.83136eea988db19842dbf9a64ca1b9cf.svg";
export { ForwardRef as ReactComponent };